import React, { useState } from "react";
import IconsGen from "../../../icons_generator/IconsGen";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import dateFormat from "dateformat";
import CurrencyAddAndUpdate from "../../../modals/CurrencyAddAndUpdate"; 
import Form from "react-bootstrap/Form";
import AxiosController from "../../../authentication/AxiosController";

const CurrencyTable = ({ data, fetchCurrency }) => {
  const { slug, lang } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [_] = useTranslation("global");
  const [show, setShow] = useState(false);
  const [showImageEdit, setShowImageEdit] = useState(false);
  const [id, setid] = useState(null);
  const [editData, setEditData] = useState(null);
  const statues = ["Active", "Inactive"];
  const [loading, handleLoader] = useState(false);

  const StatusColors = {
    Active: "rgb(28, 152, 47)",
    Inactive: "rgb(255, 0, 0)",
  };

  const change_currency_status = (currencyId) => {
    AxiosController.put(
      `api/${slug}/${lang}/currencies/switch-activation/${currencyId}`, 
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((res) => {
        handleLoader(false);
        fetchCurrency();
      })
      .catch((e) => {
        console.error(e);
        handleLoader(false);
      });
  };
  const change_currency_publicity = (currencyId) => {
    AxiosController.put(
      `api/${slug}/${lang}/currencies/switch-public/${currencyId}`, 
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((res) => {
        handleLoader(false);
        fetchCurrency();
      })
      .catch((e) => {
        console.error(e);
        handleLoader(false);
      });
  };

  return (
    <div
      style={{ borderRadius: "40px" }}
      className={`table-responsive border my-3 d-flex ${lang === "en" ? "flex-row" : "flex-row-reversed"} align-items-center`}
    >
      <table className="table table-borderless" htmlFor="flexCheckDefault">
        <thead>
          <tr style={{ textAlign: "center" }}>
            <th>
              <div className="mt-4">
                <input
                  className="form-check-input"
                  style={{
                    border: "1px solid rgba(243, 168, 55, 1)",
                    transform: "translate(-0%, -50%)",
                  }}
                  type="checkbox"
                  value=""
                  id="flexCheckDefault"
                />
              </div>
            </th>
            <th>{_("panel.date")}</th>
            <th>{_("panel.image")}</th>
            <th>{_("panel.alt_name")} </th>
            <th>{_("panel.currency_name")} </th>
            <th>{_("panel.slug")}</th>
            <th>{_("panel.country")}</th>
            <th>{_("panel.status")}</th>
            <th>{_("panel.public")}</th>
            <th>{_("panel.updateImage")}</th>
            <th>{_("panel.update")}</th>
            <th>{_("panel.enter")}</th>
          </tr>
        </thead>
        <tbody>
          {data.map((ele) => (
            <tr key={ele.id}>
              <td>
                <div>
                  <input
                    className="form-check-input"
                    style={{
                      border: "1px solid rgba(243, 168, 55, 1)",
                      transform: "translate(-0%, -50%)",
                    }}
                    type="checkbox"
                    value=""
                    id="flexCheckDefault"
                  />
                </div>
              </td>
              <td>
                {dateFormat(ele["created_at"], "dd/mm/yyyy ")} <br />
                {dateFormat(ele["created_at"], " h:MM TT")}
              </td>
              <td>
                <img src={ele["image"]} width={"69px"} className="rounded" alt="Currency" />
              </td>
              <td>{ele["alt_name"]}</td>
              <td>{ele["name"]}</td>
              <td>{ele["slug"]}</td>
              <td>{ele["country"]}</td>
              <td>
                <Form.Select
                  style={{
                    margin:"-3px",
                    border: "1px solid " + StatusColors[ele["is_active"] == "1" ? statues[0] : statues[1]],
                    color: StatusColors[ele["is_active"] == "1" ? statues[0] : statues[1]],
                  }}
                  onChange={() => {
                    handleLoader(true);
                    change_currency_status(ele["id"]);
                  }}
                >
                  <option selected={true} value={ele["is_active"] == "1" ? statues[0] : ""}>
                    {ele["is_active"] == "1" ? _(`panel.${statues[0]}`) : _(`panel.${statues[1]}`)}
                  </option>
                  {statues.map((status, index) => {
                    if (status !== (ele["is_active"] == "1" ? statues[0] : statues[1])) {
                      return (
                        <option key={index} value={status}>
                          {_(`panel.${status}`)}
                        </option>
                      );
                    }
                  })}
                </Form.Select>
              </td>
              <td>
                <Form.Select
                  style={{ 
                    border: "1px solid " + StatusColors[ele["is_public"] == "1" ? statues[0] : statues[1]],
                    color: StatusColors[ele["is_public"] == "1" ? statues[0] : statues[1]],
                  }}
                  onChange={() => {
                    handleLoader(true);
                    change_currency_publicity(ele["id"]);
                  }}
                >
                  <option selected={true} value={ele["is_public"] == "1" ? statues[0] : ""}>
                    {ele["is_public"] == "1" ? _(`panel.${statues[0]}`) : _(`panel.${statues[1]}`)}
                  </option>
                  {statues.map((status, index) => {
                    if (status !== (ele["is_public"] == "1" ? statues[0] : statues[1])) {
                      return (
                        <option key={index} value={status}>
                          {_(`panel.${status}`)}
                        </option>
                      );
                    }
                  })}
                </Form.Select>
              </td>
              <td>
                <div
                  onClick={() => {
                    setShowImageEdit(true);
                    setid(ele["id"]);
                    setEditData(ele);
                  }}
                >
                  <IconsGen icon_name={"enter"} />
                </div>
              </td>
              <td
                onClick={() => {
                  setShow(true);
                  setid(ele["id"]);
                  setEditData(ele);
                }}
              >
                <IconsGen icon_name={"enter"} />
              </td>
              <td
                onClick={()=>navigate(`/${slug}/${lang}/panel/settings/countries/${ele["id"]}`)}
              >
                <IconsGen icon_name={"enter"} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <CurrencyAddAndUpdate
        show={show}
        setShow={setShow}
        showImageEdit={showImageEdit}
        setShowImageEdit={setShowImageEdit}
        update={true}
        id={id}
        data={editData}
        fetchCurrency={fetchCurrency}
      />
    </div>
  );
};

export default CurrencyTable;
